import React, { ReactNode } from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import styles from './pagecard.module.scss';
import Card from './Card';
import CardHeader from './CardHeader';
import PromiseLoadingSpinner from '../loaders/PromiseLoadingSpinner';

interface Props {
  children: ReactNode;
  title: string;
  subtitle?: string;
  icon?: IconProp;
  iconColor?: string;
  background?: string;
  expandToHeight?: boolean;
  cardClassName?: string;
  headerClassName?: string;
  headerActionBtns?: () => JSX.Element [];
  bodyClassName?: string;
  loadingAreaName?: string;
  loadingDelay?: number;
}

const PageCard = (props: Props) => {

  const getBodyClass = (bodyClass?: string) => {
    return bodyClass !== undefined ? ` ${bodyClass}` : "";
  };

  const renderChildren = () => {
    if (props.loadingAreaName) {
      return (
        <div className={`card-body position-relative ${styles.cardBody}${getBodyClass(props.bodyClassName)}`}>
          {props.children}
          <PromiseLoadingSpinner
            area={props.loadingAreaName}
            delay={props.loadingDelay !== undefined ? props.loadingDelay : 100}
          />
        </div>
      );
    } else {
      return (
        <div className={`card-body ${styles.cardBody}${getBodyClass(props.bodyClassName)}`}>
          {props.children}
        </div>
      );
    }
  }

  return (
    <Card className={props.cardClassName} expandToHeight={props.expandToHeight}>
      <CardHeader
        title={props.title}
        subtitle={props.subtitle}
        icon={props.icon}
        iconColor={props.iconColor}
        background={props.background}
        className={props.headerClassName}
        actionBtns={props.headerActionBtns}
      />
      {renderChildren()}
    </Card>
  )
}

export default PageCard;
